module.exports = __webpack_public_path__ + "static/image/logo-family/logo_gift@3x.png?7879564a";